import CommonStore from './commonStore/CommonStore';
import BoardStore from './boardStore/BoardStore';
import CompanyStore from './companyStore/CompanyStore';
import UserInfoStore from './userInfoStore/UserInfoStore';
import CenterInfoStore from './centerInfoStore/CenterInfoStore';
import GoodsInfoStore from './goodsInfoStore/GoodsInfoStore';
import GoodsJobStore from './goodsJobStore/GoodsJobStore';
import GoodsGroupStore from './goodsGroupStore/GoodsGroupStore';
import OrderStore from './orderStore/OrderStore';
import TransStore from './transStore/TransStore';
import SettleStore from './settleStore/SettleStore';
import OrderReturnStore from './orderReturnStore/OrderReturnStore';
import StatsStore from './statsStore/StatsStore';

class RootStore {
  constructor(){
    // 공통
    this.commonStore = new CommonStore(this);
    // 게시판
    this.boardStore = new BoardStore(this);
    // 회사정보
    this.companyStore = new CompanyStore(this);
    
    // 사원정보관리 & 직무정보관리
    this.userInfoStore = new UserInfoStore(this);
    // 센터정보관리
    this.centerInfoStore = new CenterInfoStore(this); 
    
    // 상품관리
    this.goodsInfoStore = new GoodsInfoStore(this);
    // 상품이용정보관리
    this.goodsJobStore = new GoodsJobStore(this);
    // 상품군관리
    this.goodsGroupStore = new GoodsGroupStore(this);

    
    // 주문
    this.orderStore = new OrderStore(this);

    // 주문이력
    this.transStore = new TransStore(this);

    // 정산관리
    this.settleStore = new SettleStore(this);

    // 반품
    this.orderReturnStore = new OrderReturnStore(this);

    // 통계
    this.statsStore = new StatsStore(this);
    
  }
}
export default RootStore;